import * as actions from './extIndiamart.actions';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExtIndiamartConfigModel } from '@smarttask-common/src/lib/models/Integrations/Indiamart/ExtIndiamartConfigModel';

export const configAdapter = createEntityAdapter<ExtIndiamartConfigModel>({
    selectId: (x) => x.config_id,
});

export interface ExtIndiamartConfigState extends EntityState<ExtIndiamartConfigModel> {
    selected_config_id: string;
}

export const initialState: ExtIndiamartConfigState = configAdapter.getInitialState({
    selected_config_id: undefined,
});

export function ExtIndiamartConfigReducers(state: ExtIndiamartConfigState = initialState, action: actions.ExtIndiamartConfigActions) {
    switch (action.type) {
        case actions.ExtIndiamartConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_config_id: action.selected_config_id };
            return state;

        case actions.ExtIndiamartConfigActionTypes.ADD_EXT_INDIAMART_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.ExtIndiamartConfigActionTypes.ADD_EXT_INDIAMART_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.ExtIndiamartConfigActionTypes.UPSERT_EXT_INDIAMART_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.ExtIndiamartConfigActionTypes.UPSERT_EXT_INDIAMART_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.ExtIndiamartConfigActionTypes.UPDATE_EXT_INDIAMART_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.ExtIndiamartConfigActionTypes.UPDATE_EXT_INDIAMART_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.ExtIndiamartConfigActionTypes.DELETE_EXT_INDIAMART_CONFIG:
            return configAdapter.removeOne(action.config_id, state);

        case actions.ExtIndiamartConfigActionTypes.DELETE_EXT_INDIAMART_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.ExtIndiamartConfigActionTypes.DELETE_ALL_EXT_INDIAMART_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.ExtIndiamartConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getExtIndiamartConfigState = createFeatureSelector<ExtIndiamartConfigState>('extIndiamartConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getExtIndiamartConfigState);

const getSelectedConfigIdState = (state: ExtIndiamartConfigState) => state.selected_config_id;
export const getSelectedConfigId = createSelector(getExtIndiamartConfigState, getSelectedConfigIdState);

export const getSelectedConfig = createSelector(getExtIndiamartConfigState, (state: ExtIndiamartConfigState) => {
    if (state.selected_config_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_config_id];
});
